// File: src/pages/Inbox.jsx

import React, { useEffect, useState, useContext } from "react";
import { Link } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";
import "../styles/Inbox.css";

export default function Inbox() {
  const { token, user } = useContext(AuthContext);
  const [chats, setChats] = useState([]);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchInbox = async () => {
      try {
        const res = await fetch(`http://localhost:5000/api/chats/inbox`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        const data = await res.json();
        if (!res.ok) throw new Error(data?.msg || "Failed to fetch inbox");

        // 🛡️ Ensure it's always an array
        if (!Array.isArray(data)) {
          throw new Error("Unexpected inbox format");
        }

        setChats(data);
      } catch (err) {
        console.error("❌ Inbox error:", err.message);
        setError("Failed to load inbox.");
      }
    };

    if (token) fetchInbox();
  }, [token]);

  return (
    <div className="inbox-page">
      <h2>📥 Your Messages</h2>

      {error && <p className="error">{error}</p>}

      {chats.length === 0 ? (
        <p className="no-messages">No conversations yet.</p>
      ) : (
        <ul className="chat-list">
          {chats.map((chat, i) => {
            const otherUser =
              chat.participants?.find((p) => p?._id !== user?._id) || {};

            return (
              <li key={i} className="chat-item">
                <Link to={`/chat/${otherUser._id}`}>
                  <strong>{otherUser.name || "Unknown User"}</strong>
                  <p>{chat.latestMessage?.message || "No message yet"}</p>
                  <small>
                    {chat.latestMessage?.createdAt
                      ? new Date(chat.latestMessage.createdAt).toLocaleString()
                      : "Unknown time"}
                  </small>
                </Link>
              </li>
            );
          })}
        </ul>
      )}
    </div>
  );
}
